import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import {
  Grid,
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  Checkbox,
  Box,
} from "@mui/material";
import * as Yup from "yup";
import CustomDropzone from "components/Dropzone";
import {
  GradientButton,
  GradientButtonOutline,
} from "components/GradientButton";
import api from "_api";
import Swal from "sweetalert2";
import "assets/css/modal.css";
import SaveIcon from "assets/images/SaveIcon.svg";
import { Image, Switch } from "antd";

const ViewModal = ({ open, onClose, selectedProduct }) => {
  const [initialProductUrls, setInitialProductUrls] = useState([]);
  const [files, setFiles] = useState([]);
  const roleOption = [
    { label: "แอดมิน", id: 1 },
    { label: "เจ้าของร้าน", id: 2 },
    { label: "หัวหน้าแอดมินการอนุมัติ", id: 3 },
    { label: "หัวหน้าแอดมินการจัดการ", id: 4 },
    { label: "แอดมินการอนุมัติ", id: 5 },
    { label: "แอดมินการจัดการ", id: 6 },
  ];

  const productFields = [
    {
      label: "ชื่อผู้ใช้งาน",
      name: "username",
      type: "text",
    },
    {
      label: "ชื่อ-นามสกุล",
      name: "name",
      type: "text",
      required: true,
    },
    {
      label: "ชื่อร้าน/บริษัท",
      name: "Company",
      type: "text",
      required: true,
    },
    // ...(!selectedProduct
    //   ? [
    //       {
    //         label: "รหัสผ่าน",
    //         name: "password",
    //         type: "password",
    //         required: true,
    //       },
    //       {
    //         label: "ยืนยันรหัสผ่าน",
    //         name: "confirmPassword",
    //         type: "password",
    //         required: true,
    //       },
    //     ]
    //   : []),
    {
      label: "สิทธิ์ที่สร้าง",
      name: "role_id",
      type: "text",
      required: true,
    },
    {
      label: "สถานะ",
      name: "status",
      type: "checkbox",
      required: false,
    },
  ];

  useEffect(() => {
    console.log({ selectedProduct });
    if (selectedProduct) {
      if (selectedProduct?.image) {
        setFiles([
          {
            file: null,
            url: selectedProduct?.image,
            id: selectedProduct?.user_id,
            status: "complete",
          },
        ]);
      }
    }
  }, [selectedProduct]);

  const renderFields = (fields, value) => {
    return fields.map((field, index) => (
      <React.Fragment key={index}>
        <Grid item xs={12} sm={2}>
          <Typography variant="subtitle1">{field.label}</Typography>
        </Grid>
        <Grid item xs={12} sm={10}>
          {field.type === "checkbox" ? (
            <Switch value={value[field?.name] ?? false} disabled />
          ) : field.name === "role_id" ? (
            // <TextField
            //   disabled={field.disabled}
            //   id={field.name}
            //   name={field.name}
            //   type={field.type}
            //   value={
            // roleOption.find((element) => element.id === 2)["label"] ?? ""
            //   }
            //   fullWidth
            //   slotProps={{
            //     input: { readOnly: true, disableUnderline: true },
            //   }}
            //   sx={{
            //     pointerEvents: "none",
            //   }}
            // />
            <Typography variant="subtitle1" sx={{ opacity: 0.8 }}>
              {roleOption.find((e) => e.id === value[field.name])?.label ?? ""}
            </Typography>
          ) : field.name === "Company" ? (
            <Typography variant="subtitle1" sx={{ opacity: 0.8 }}>
              {value[field.name].company_name ?? ""}
            </Typography>
          ) : (
            // <TextField
            //   disabled={field.disabled}
            //   id={field.name}
            //   name={field.name}
            //   type={field.type}
            //   value={value[field?.name] ?? ""}
            //   fullWidth
            //   slotProps={{
            //     input: { readOnly: true, disableUnderline: true },
            //   }}
            //   sx={{
            //     pointerEvents: "none",
            //   }}
            // />
            <Typography variant="subtitle1" sx={{ opacity: 0.8 }}>
              {value[field?.name] ?? ""}
            </Typography>
          )}
        </Grid>
      </React.Fragment>
    ));
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") onClose();
      }}
      disableEscapeKeyDown
      maxWidth="md"
      fullWidth
      sx={{
        borderRadius: "8px",
      }}
    >
      <DialogTitle>
        <Typography variant="h4">รายละเอียดผู้ใช้งาน</Typography>
      </DialogTitle>
      <DialogContent sx={{ padding: 0 }}>
        <Grid container spacing={3} sx={{ padding: 3 }}>
          <Grid item xs={12}>
            <Grid container spacing={2} sx={{ mb: 3 }}>
              {selectedProduct && renderFields(productFields, selectedProduct)}

              <Grid item xs={12} sm={2}>
                <Typography variant="subtitle1">รูปโปรไฟล์</Typography>
              </Grid>
              <Grid item xs={12} sm={10}>
                <Image.PreviewGroup
                  preview={{
                    getPopupContainer: () => document.body, // Ensure preview renders outside of dialog
                    zIndex: 3000,
                  }}
                >
                  <Image
                    src={selectedProduct?.image}
                    width={200}
                    height={200}
                    style={{
                      position: "absolute",
                      cursor: "pointer",
                    }}
                  />
                </Image.PreviewGroup>
                {/* <CustomDropzone files={files} isDisabled={true} /> */}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <GradientButtonOutline
          variant="outlined"
          sx={{ mr: 1 }}
          onClick={onClose}
        >
          ปิด
        </GradientButtonOutline>
      </DialogActions>
    </Dialog>
  );
};

export default ViewModal;
